<template>
    <el-form :model="devcCat" :rules="dispCatRules" :label-position="'left'" ref="devcCatInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">分类名称</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="name">
                        <el-input v-model="devcCat.name" placeholder="请输入分类名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">分类编码</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="code">
                        <el-input v-model="devcCat.code" placeholder="请输入分类编码"></el-input>
                    </el-form-item>
                </div>
            </div>
            <!--<div class="form-group center">-->
            <!--<div class="form-label">-->
            <!--<label>验收自动入账</label>-->
            <!--</div>-->
            <!--<div class="form-value width-2x">-->
            <!--<el-form-item prop="fiscalAcctAutoIn">-->
            <!--<el-radio-group v-model="devcCat.fiscalAcctAutoIn">-->
            <!--<el-radio :label="true">是</el-radio>-->
            <!--<el-radio :label="false">否</el-radio>-->
            <!--</el-radio-group>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--</div>-->
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">使用年限(月)</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="durableLife" :rules="{validator: checkDurableLife, trigger: 'blur'}">
                        <el-input type="number" v-model="devcCat.durableLife" placeholder="请输入使用年限"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">需要供应商提供唯一标识码</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="vendorUknoFlag">
                        <el-radio-group v-model="devcCat.vendorUknoFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getMerchantBizParam} from '../asset/assetMain';

    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-devc-cat-save',
        desc: '',
        props: ["item"],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkCode = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                devcCat: {
                    vendorUknoFlag: false,
                    durableLife: 60
                },
                dispCatRules: {
                    name: [{validator: checkNull, trigger: 'blur'}],
                    code: [{validator: checkCode, trigger: 'blur'}]
                }
            }
        },
        created: function () {
            this.getInit();
        },
        methods: {
            checkDurableLife: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('使用年限不可为空!'));
                } else {
                    if (Utils.isNaturalStr(value)) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的整数!'));
                    }
                }
            },
            getInit: function () {
                let self = this;
                //
                let item = self.item;
                if (!Utils.isNoB(item.id)) {
                    let postData = {};
                    postData.id = item.id;
                    let theLoad = MsgBox.loading();
                    shopDevcApi.getDevcCatById(postData, function (result) {
                        theLoad.hide();
                        if (result.type === 'info') {
                            let devcCat = result.data;
                            if (Utils.isNoB(devcCat.vendorUknoFlag)) {
                                devcCat.vendorUknoFlag = false;
                            }
                            //
                            self.devcCat = Utils.merge({}, devcCat);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    if (!Utils.isNoB(item) && !Utils.isNoB(item.parentId)) {
                        self.devcCat = item;
                    }
                }
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['devcCatInfo'].validate(function (valid) {
                    if (valid) {
                        result.type = "info";
                        let devcCat = self.devcCat;
                        if (devcCat.name != null) {
                            devcCat.name = devcCat.name.trim();
                        }

                        if (devcCat.code != null) {
                            devcCat.code = devcCat.code.trim();
                        }
                        result.type = 'info';
                        result.data = devcCat;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcCatSave.vue